import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import type { NavigationItem } from '@layout/data/navigation';
import {
  BuiSidebar,
  BuiSidebarBadge,
  BuiSidebarBody,
  BuiSidebarButton,
  BuiSidebarHeader,
  BuiSidebarIcon,
  BuiSidebarLabel,
  BuiSidebarMenu,
  BuiSidebarMenuItem,
  BuiSidebarMenuRow,
  BuiSidebarSection,
  BuiSidebarSectionContent,
} from '@ui/sidebar';

@Component({
  selector: 'app-secondary-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    RouterLinkActive,
    MatIcon,
    TranslocoDirective,
    BuiSidebar,
    BuiSidebarBadge,
    BuiSidebarBody,
    BuiSidebarButton,
    BuiSidebarHeader,
    BuiSidebarIcon,
    BuiSidebarLabel,
    BuiSidebarMenu,
    BuiSidebarMenuItem,
    BuiSidebarMenuRow,
    BuiSidebarSection,
    BuiSidebarSectionContent,
  ],
  host: {
    class: 'flex h-full w-full',
  },
  template: `
    <aside
      buiSidebar
      class="flex-auto"
      *transloco="let t"
    >
      <!-- Header -->
      <div
        buiSidebarHeader
        class="border-b px-4 py-6"
      >
        <div class="text-xl font-medium">
          {{ t(title()) }}
        </div>
      </div>

      <!-- Body -->
      <div buiSidebarBody>
        <div buiSidebarSection>
          <div buiSidebarSectionContent>
            <ul buiSidebarMenu>
              @for (child of items(); track child.id) {
                <li buiSidebarMenuItem>
                  <div buiSidebarMenuRow>
                    <a
                      buiSidebarButton
                      [routerLink]="child.route"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="
                        child.routeActiveOptions ?? { exact: true }
                      "
                      (click)="itemClick.emit()"
                    >
                      @if (child.icon) {
                        <mat-icon
                          buiSidebarIcon
                          [svgIcon]="child.icon"
                        />
                      }
                      <span buiSidebarLabel>{{ t(child.label!) }}</span>
                      @if (child.badge) {
                        <div buiSidebarBadge>{{ child.badge }}</div>
                      }
                    </a>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </aside>
  `,
})
export class AppSecondarySidebar {
  readonly title = input.required<string>();
  readonly items = input.required<NavigationItem[]>();
  readonly itemClick = output();
}
